// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

const CNTLR_NAME = "apiSession";

export const keepAlive = () => http.get(`${CNTLR_NAME}/keepAlive`,{silent:true}).then(getData);